import getters from './getters';
import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    create: {
      basic: {
        name: null,
        description: null,
        extra_description: null,
        cost: 0,
        price: 0,
        discount: 0,
        vat: 0,
        weight: 0,
        status: false,
        on_sale: false,
        require_shipping: false,
        homepage_feature: false,
        dimension: null,
      },
      catalog: {},
      outlets: {},
      attributes: {},
      available: {},
      config: {
        daily_order_limit: null,
        minimum_order: null,
      },
    },
    edit: {
      basic: {
        name: null,
        description: null,
        extra_description: null,
        cost: 0,
        price: 0,
        discount: 0,
        vat: 0,
        weight: 0,
        status: false,
        on_sale: false,
        require_shipping: false,
        homepage_feature: false,
        dimension: null,
      },
      catalog: {},
      outlets: {},
      attributes: {},
      available: {},
      config: {
        daily_order_limit: null,
        minimum_order: null,
      },
    },
    images: [],
    delete: {
      catalog: {},
      outlets: {},
      attributes: {},
      available: {},
      config: {
        daily_order_limit: null,
        minimum_order: null,
      },
    },
    products: [],
    searchResults: [],
    pagination: {
      total: 1,
      perPage: 10,
      page: 1,
      lastPage: 1,
    },
    csvUploads: [],
    filter: 'name',
    direction: 'asc',
    query: '',
    socketMessages: [],
  },
  actions,
  mutations,
  getters,
};
